import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class GlobalLoaderService {
  loaderSubject = new BehaviorSubject<boolean>(false);
  constructor() {}

  triggerLoader(value: boolean) {
    this.loaderSubject.next(value);
  }
  getLoader() {
    return this.loaderSubject.asObservable();
  }
}
